$(function(){
    $('.iwish-seo-setting .seo-buttom span').on('click',function(){
        let t = $(this).text();
        if(t == 'Mostrar más'){
            $('.iwish-seo-setting .seo-container').removeClass('max-height');
            $(this).html('Emboscar');
        }else{
            $('.iwish-seo-setting .seo-container').addClass('max-height');
            $(this).html('Mostrar más');
        }
    });
});